import { Switch } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { db } from "../../config/Firebase";
import { useAuth } from "../../context/AuthContext";
import { getStripeRole, goToBillingPortal } from "../../config/Firebase";
import Button from '@material-ui/core/Button';

import { CircularProgress, InputBase } from "@material-ui/core";
const Profile = () => {
  const { activeUser } = useAuth();
  const [checked,setChecked] = useState(false);
  const [isCheckoutLoading, setIsCheckoutLoading] = useState(false);
  const [roleValue, setRoleValue] = useState(null);

  useEffect(()=>{
    setChecked(activeUser.notificationsEnabled);
    getStripeRole().then(result => {
      setRoleValue(result);
    });
  },[activeUser]);



  return (
    <div className="py-5">
      <div className="container emp-profile mt-5">
      <form method="post">
        <div className="row">
          <div className="col-md-4">
            <div className="profile-img">
              <div className="bg-light rounded-circle d-flex justify-content-center align-items-center display-2 border shadow" style={{width: `200px`,height: `200px`}}> {activeUser.firstname[0]} </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="profile-head">
              <h5>{activeUser.firstname} {activeUser.lastname}</h5>
              <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item">
                  <Link to="/profile" className="nav-link active">About</Link>
                </li>
              </ul>
            </div>
            <div className="w-100"></div>
            <div className="tab-content profile-tab" id="myTabContent">
              <div className="tab-pane fade show active" id="home">
                <div className="row">
                  <div className="col-md-6">
                    <label>First Name</label>
                  </div>
                  <div className="col-md-6">
                    <p>{activeUser.firstname}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label>Last Name</label>
                  </div>
                  <div className="col-md-6">
                    <p>{activeUser.lastname}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label>Email</label>
                  </div>
                  <div className="col-md-6">
                    <p>{activeUser.email}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label>Notifications</label>
                  </div>
                  <div className="col-md-6">
                    <p><Switch checked={checked} onChange={()=> {
                      db.collection("users").doc(activeUser.id).update({notificationsEnabled: !checked})
                    }} /></p>
                  </div>
                </div>
                <div className="row">
                <Button 
                  className="btn btn-call rounded-pill px-3" variant="contained"  color="primary"
                  onClick={() => {
                    setIsCheckoutLoading(true);
                    goToBillingPortal();
                  }}
                  >
                    Billing Dashboard
                </Button>
                {
                  isCheckoutLoading ?
                  <CircularProgress /> : <></>
                }
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    </div>
     
  );
};

export default Profile;
